<template>
  <div data-test-id="yours-tab-menu">
    <div
      class="row no-wrap items-center q-py-xs bg-responsive-white text-responsive-grey-9 text-subtitle2 header-bar"
    >
      <div class="col">
        {{ ownPermissions.length }} permissions
      </div>
      <div class="col-auto">
        <q-btn
          label="Select All"
          flat
          dense
          :ripple="false"
          @click="selectAll"
        />
      </div>
    </div>
    <permissions-by-category-list
      :permissions="ownPermissions"
      :selected-permission-actions="previewedPermissionActions"
      @click-permission="handlePermissionClick"
    />
    <q-inner-loading :showing="permissions.loading" />
  </div>
</template>

<script>
import Model from 'src/models/model'
import PermissionsByCategoryList from 'src/modules/admin/role/PermissionsByCategoryList'

export default {
  name: 'PermissionsTabMenu',
  components: {
    PermissionsByCategoryList
  },
  props: {
    previewedPermissionActions: {
      type: Array,
      required: true
    }
  },
  emits: ['unselect-permission-actions', 'select-permission-actions'],
  data () {
    return {
      searchString: ''
    }
  },
  models: {
    permissions: {
      action: true,
      label: true,
      category: true,
      displayOrder: true
    }
  },
  computed: {
    ownPermissions () {
      return _.filter(this.permissions.data, permission => {
        return _.includes(Model.context.permittedFrontendActions, permission.action)
      })
    }
  },
  methods: {
    handlePermissionClick (permission) {
      if (_.includes(this.previewedPermissionActions, permission.action)) {
        this.$emit('unselect-permission-actions', permission.action)
      } else {
        this.$emit('select-permission-actions', permission.action)
      }
    },
    selectAll () {
      this.$emit('select-permission-actions', _.map(this.ownPermissions, 'action'))
    }
  }
}
</script>

<style scoped>
.header-bar {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
